var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.69,
    height: 8,
    viewBox: "0 0 4.69 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-last-page",
    d: "M1.354.219c.288.281,3.1,3.238,3.1,3.238a.755.755,0,0,1,0,1.087S1.642,7.5,1.354,7.782a.82.82,0,0,1-1.114,0A.733.733,0,0,1,.24,6.7L2.824,4,.24,1.306A.735.735,0,0,1,.24.219.819.819,0,0,1,1.354.219Z",
    transform: "translate(4.69 8) rotate(180)",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLast);
export default __webpack_public_path__ + "static/media/last.83fab07347afc6901e57bba8821b23fa.svg";
export { ForwardRef as ReactComponent };